import request from "@/utils/request";

export function saveBill (data){
  return request({
    url:'/osp/online-order/saveBill',
    method:'post',
    data: data
  })
}

export function pushBillToEAS (data){
  return request({
    url:'/osp/online-order/pushBillToEAS',
    method:'post',
    data: data
  })
}

export function querySaleOrderList (data){
  return request({
    url:'/osp/online-order/querySaleOrderPageList',
    method:'post',
    data: data
  })
}

export function querySaleOrderFromEAS (data){
  return request({
    url:'/osp/online-order/querySaleOrderFromEAS',
    method:'post',
    data: data
  })
}

export function querySaleIssueBill (data){
  return request({
    url:'/osp/online-order/querySaleIssueBill',
    method:'post',
    data: data
  })
}

export function deleteSaleOrder (data){
  return request({
    url:'/osp/online-order/deleteSaleOrder',
    method:'post',
    data: data
  })
}

export function editSaleOrder (data){
  return request({
    url:'/osp/online-order/editSaleOrder',
    method:'post',
    data: data
  })
}

export function getBalanceAmount (data){
  return request({
    url:'/osp/online-order/getBalanceAmount',
    method:'post',
    data: data
  })
}
